import { Component} from '@angular/core';
import { LoaderSpinnerService } from '@carm/_core/interceptors/loader-spinner.service';
@Component({
    selector: 'carm-loader-spinner',
    templateUrl: './loader-spinner.component.html',
    styleUrls: ['./loader-spinner.component.scss'],
  })
  export class LoaderSpinnerComponent {

    constructor(public loaderSpinnerService: LoaderSpinnerService){


    }
  }
